import { render, staticRenderFns } from "./noticeThree.vue?vue&type=template&id=202f6605&scoped=true"
import script from "./noticeThree.vue?vue&type=script&lang=js"
export * from "./noticeThree.vue?vue&type=script&lang=js"
import style0 from "./noticeThree.vue?vue&type=style&index=0&id=202f6605&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f6605",
  null
  
)

export default component.exports